<template>
  <div id="app" class="fullscreen-app">
    <router-view/>

    <!-- Above the router so every screen reaches them and route changes don't tear them down. -->
    <settings-modal :first-run="firstRun" />
    <tutorial-overlay :target-language="targetLanguage.name" />
    <share-sheet />
    <feedback-sheet />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SettingsModal from './components/settings/SettingsModal';
import TutorialOverlay from './components/tutorial/TutorialOverlay.vue';
import ShareSheet from './components/share/ShareSheet.vue';
import FeedbackSheet from './components/feedback/FeedbackSheet.vue';

export default {
  name: 'App',
  components: { SettingsModal, TutorialOverlay, ShareSheet, FeedbackSheet },
  computed: {
    ...mapState('settings', ['firstRun', 'targetLanguage'])
  }
}
</script>

<style>
#app {
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text);
  margin-top: 0px;
  /* Disable double-tap zoom */
  touch-action: manipulation;
  -ms-touch-action: manipulation;
}

.fullscreen-app {
  height: 100vh; /* Fallback for browsers that don't support dvh */
  height: 100dvh; /* Dynamic viewport height - adjusts for browser UI elements */
  width: 100%;
  max-width: 800px; /* Adding max-width as requested */
  max-height: 952px; /* Adding max-height */
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0; /* Add right:0 to help with centering */
  margin-left: auto; /* Center the app horizontally when max-width is applied */
  margin-right: auto; /* Center the app horizontally when max-width is applied */
}

button, 
a, 
input, 
select, 
textarea {
  touch-action: manipulation;
}
</style>
